import withAPIAction from 'helpers/withAPIAction'
import {
  GrnListReq,
  CreateGrnReq,
  UpdateGrnReq,
  DeleteGrnReq,
  GrnDetailReq,
  LatestGrnReq,
  LatestGrnListReq,
  CountReq,
  GrnImproveListReq,
} from './types'
import {
  getGrnListAction,
  createGrnAction,
  updateGrnAction,
  deleteGrnAction,
  getGrnDetailAction,
  getGrnListBySupAction,
  getLastesGrnAction,
  getLastesGrnListAction,
  getCountAction,
  getGrnImproveListAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'
import { getRequestString } from 'helpers/format'

export const grnListAPI = (data: GrnListReq, token: string, xmid: string) => {
  return withAPIAction<GrnListReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: `${APIPath.grnList}?${getRequestString(data)}`,
    data,
    token,
    xmid,
  })(getGrnListAction)
}

export const createGrnAPI = (data: CreateGrnReq, token: string, xmid: string) => {
  return withAPIAction<CreateGrnReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.createGrn,
    data,
    token,
    xmid,
  })(createGrnAction)
}

export const updateGrnAPI = (data: UpdateGrnReq, token: string, xmid: string) => {
  return withAPIAction<UpdateGrnReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.updateGrn,
    data,
    token,
    xmid,
  })(updateGrnAction)
}

export const deleteGrnAPI = (data: DeleteGrnReq, token: string, xmid: string) => {
  return withAPIAction<DeleteGrnReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.deleteGrn,
    data,
    token,
    xmid,
  })(deleteGrnAction)
}

export const getGrnDetailAPI = (data: GrnDetailReq, token: string, xmid: string) => {
  return withAPIAction<GrnDetailReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.getGrnByID,
    data,
    token,
    xmid,
  })(getGrnDetailAction)
}

export const grnListBySupActionAPI = (data: GrnListReq, token: string, xmid: string) => {
  return withAPIAction<GrnListReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: `${APIPath.grnList}`,
    data,
    token,
    xmid,
  })(getGrnListBySupAction)
}

export const getLatestGrnAPI = (data: LatestGrnReq, token: string, xmid: string) => {
  return withAPIAction<LatestGrnReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.latestGrn}`,
    data,
    token,
    xmid,
  })(getLastesGrnAction)
}

export const getLatestGrnListAPI = (data: LatestGrnListReq, token: string, xmid: string) => {
  return withAPIAction<LatestGrnListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.latestGrnList}`,
    data,
    token,
    xmid,
  })(getLastesGrnListAction)
}

export const getCountAPI = (data: CountReq, token: string, xmid: any) => {
  return withAPIAction<CountReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.countGrn}`,
    data,
    token,
    xmid,
  })(getCountAction)
}

export const grnImproveListAPI = (data: GrnImproveListReq, token: string, xmid: string) => {
  return withAPIAction<GrnImproveListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.grnImroveList}`,
    data,
    token,
    xmid,
  })(getGrnImproveListAction)
}
